import React from "react";
import styles from "./index.module.scss";

const DashboardCard = ({ title, icon, variant, handleClick }) => {
  const getVariant = () => {
    switch (variant) {
      case "v1":
        return styles.variant_1;
      case "v2":
        return styles.variant_2;
      case "v3":
        return styles.variant_3;
      case "v4":
        return styles.variant_4;
      case "v5":
        return styles.variant_5;

      default:
        break;
    }
  };


  return (
    <div className={styles.container}>
      <div
        className={`${styles.cardInner} ${getVariant()}`}
        onClick={handleClick && handleClick}
      >
        <div className={styles.effectOverlay}>&nbsp;</div>
        <h5>{title}</h5>
        <span>{icon}</span>
      </div>
    </div>
  );
};

export default DashboardCard;
